import { render, staticRenderFns } from "./NovoManualDeRedacao.vue?vue&type=template&id=0cc1aaa5"
import script from "./NovoManualDeRedacao.vue?vue&type=script&lang=js"
export * from "./NovoManualDeRedacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports